var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:'sidebar-mini ' +  _vm.globalFontTable,style:('font-size: ' + _vm.globalFontsize + '!important'),attrs:{"data-app":""}},[_c('notifications'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }